var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isCounting)?_c('div',{staticClass:"authentication-resend-wait"},[_vm._v("\n    Você poderá reenviar o código em "),_c('span',[_vm._v(_vm._s(_vm.formattedTime))])]):_c('div',{staticClass:"authentication-resend"},[_vm._v("\n    Não recebeu o código?\n    "),_vm._t("resend")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }